import { Sparkles } from "lucide-react";
import { ActionCard, ResultCard } from "@/components/agent/ActionCard";

const inline = (text) => text.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith("**") && p.endsWith("**") ? <strong key={i}>{p.slice(2, -2)}</strong> : p));
const CHOICES = /\[\[([^\]]+)\]\]/g;

// Le risposte rapide arrivano dall'assistente come [[Sì|No|Altro]]: diventano pulsanti.
export const splitChoices = (text = "") => {
  const all = [...text.matchAll(CHOICES)];
  const body = text.replace(CHOICES, "").replace(/\[\[[^\]]*$/, "").trimEnd();
  const last = all[all.length - 1];
  return [body, last ? last[1].split("|").map((s) => s.trim()).filter(Boolean).slice(0, 4) : []];
};

// Markdown minimale: grassetto, elenchi puntati, paragrafi.
export const RichText = ({ text }) => {
  const blocks = [];
  let list = null;
  (text || "").split("\n").forEach((line, i) => {
    const m = line.match(/^\s*(?:[-•*]|\d+\.)\s+(.*)$/);
    if (m) {
      if (!list) { list = []; blocks.push(<ul key={`u${i}`} className="list-disc pl-5 space-y-0.5 my-1">{list}</ul>); }
      list.push(<li key={i}>{inline(m[1])}</li>);
    } else {
      list = null;
      const h = line.match(/^#{1,4}\s+(.*)$/);
      if (h) blocks.push(<div key={i} className="font-semibold mt-2">{inline(h[1])}</div>);
      else if (line.trim()) blocks.push(<p key={i} className="my-1">{inline(line)}</p>);
    }
  });
  return <div className="text-[15px] leading-relaxed" data-no-translate>{blocks}</div>;
};

const Choices = ({ items, onPick }) => (
  <div className="flex flex-wrap gap-2" data-testid="agent-quick-replies">
    {items.map((c, i) => (
      <button key={c} type="button" onClick={() => onPick(c)} data-testid={`agent-quick-reply-${i}`}
        className="min-h-[44px] px-4 rounded-full border border-primary/40 bg-primary/5 text-primary text-sm font-semibold hover:bg-primary hover:text-primary-foreground transition-colors">{c}</button>
    ))}
  </div>
);

export const ChatMessage = ({ m, busyAction, onConfirm, onCancel, onQuick }) => {
  if (m.kind === "result") return <div className="pl-11"><ResultCard r={m.result || {}} /></div>;
  if (m.role === "user") {
    return (
      <div className="flex justify-end" data-testid="agent-msg-user">
        <div className="max-w-[85%] rounded-2xl rounded-br-md bg-primary text-primary-foreground px-4 py-2.5 text-[15px] whitespace-pre-wrap" data-no-translate>{m.text}</div>
      </div>
    );
  }
  const [body, choices] = splitChoices(m.text || "");
  return (
    <div className="flex gap-3" data-testid="agent-msg-assistant">
      <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary to-orange-400 text-white flex items-center justify-center shrink-0"><Sparkles className="w-4 h-4" /></div>
      <div className="flex-1 min-w-0 space-y-2.5">
        {(body || m.streaming) && (
          <div className="rounded-2xl rounded-tl-md bg-secondary/70 px-4 py-2.5 max-w-[95%] inline-block">
            <RichText text={body} />
            {m.streaming && <span className="inline-block w-2 h-4 bg-primary/70 animate-pulse align-middle ml-0.5" />}
          </div>
        )}
        {m.status && <div className="text-xs text-muted-foreground italic" data-testid="agent-status">{m.status}…</div>}
        {(m.actions || []).map((a) => <ActionCard key={a.id} a={a} busy={busyAction === a.id} onConfirm={onConfirm} onCancel={onCancel} />)}
        {onQuick && !m.streaming && choices.length > 0 && <Choices items={choices} onPick={onQuick} />}
      </div>
    </div>
  );
};

export default ChatMessage;
